import { Injectable } from '@angular/core';
import { createInitialState, GiftVoucherFormStore } from './gift-voucher-form.store';

@Injectable({ providedIn: 'root' })
export class GiftVoucherFormService {
    constructor(
        private giftVoucherFormStore: GiftVoucherFormStore,
    ) { }

    resetGiftVoucherFormData() {
        this.giftVoucherFormStore.update(createInitialState());
    }

    resetStore() {
        this.giftVoucherFormStore.reset();
    }

    buildUrlParameters() {
        const store = this.giftVoucherFormStore.getValue();
        const name = store.isGifting ? store.name : '';
        const phone = store.isGifting ? store.phone : '';
        const email = store.isGifting ? store.email : '';
        const sendEmail = store.isGifting && store.sendEmail ? '-1' : '0';

        const params = `&ClientRefereeName=${name}&ClientRefereeSurname1=&ClientRefereeSurname2=&ClientRefereePhone=${phone}&ClientRefereeEmail=${email}&ShouldReceiveEmail=${sendEmail}`;

        return params;
    }
}
